import { Injectable } from '@angular/core';
import { Http, Response }  from '@angular/http';

@Injectable()
export class BackendService {


  constructor(
    private http: Http
  ) { }

  inviteUser(user) {
    return this.http.post('/invite', user)
                    .map(res => res.json());
  }

  resetPassword(user, newPassword) {
    let payload = {
      uid: user.$key,
      email: user.email,
      password: newPassword,
      firstName: user.firstName,
      lastName: user.lastName
    }
    return this.http.post('/reset_pw', payload)
                    .map(res => res.json());
  }

  oneSignalNotification(surveyName, notificationKey) {
    let payload = {
      surveyName: surveyName,
      notificationKey: notificationKey
    }

    return this.http.post('/notify_survey', payload)
                    .map(res => res.json());
  }

  deauthUser(key) {
    return this.http.post('/deauth', {uid: key})
                    .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/backend.service.ts